var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCloseMBold(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.515 5.636l2.121-2.121 14.85 14.849-2.122 2.121z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18.364 3.515l2.121 2.121-14.849 14.85-2.121-2.122z"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cmVjdCB4PSIzLjUxNTE0IiB5PSI1LjYzNTk5IiB3aWR0aD0iMyIgaGVpZ2h0PSIyMSIgdHJhbnNmb3JtPSJyb3RhdGUoLTQ1IDMuNTE1MTQgNS42MzU5OSkiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgogIDxyZWN0IHg9IjE4LjM2NDMiIHk9IjMuNTE0NzciIHdpZHRoPSIzIiBoZWlnaHQ9IjIxIiB0cmFuc2Zvcm09InJvdGF0ZSg0NSAxOC4zNjQzIDMuNTE0NzcpIiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPC9zdmc+Cg==";
export { SvgCloseMBold as ReactComponent };